// src/utils/analytics.js
// Track page views in our single-page app

export function trackPageView(path) {
  if (window.gtag) {
    window.gtag('config', 'G-R02G37B91H', {
      page_path: path,
    });
  }
}

export function trackEvent(action, category, label, value) {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
}